import { useState, useCallback, useMemo } from "react";
import BreakdownDialog from "./BreakdownDialog";

export const LEASE_OPTIONS_BY_TYPE_BREAKDOWN_COLUMNS = [
  { key: "asset_label", label: "Asset" },
  { key: "lessee_name", label: "Lessee" },
  { key: "lessor_name", label: "Lessor" },
  { key: "option_type", label: "Option Type" },
  { key: "validity_start_date", label: "Validity Start Date", type: "date" },
  { key: "validity_end_date", label: "Validity End Date", type: "date" },
  { key: "created_at", label: "Created On", type: "date" },
];

// Clicking a pie slice opens the popup with lease_option_breakdown filtered to that option type.
export function useLeaseOptionsByTypeBreakdown({ optionBreakdown, onTrack }) {
  const [selectedType, setSelectedType] = useState(null);
  const reset = useCallback(() => setSelectedType(null), []);

  const rows = useMemo(
    () => (selectedType ? optionBreakdown.filter((item) => (item?.option_type || "Unknown") === selectedType) : []),
    [optionBreakdown, selectedType],
  );

  const chartEvents = useMemo(() => ({
    click: (params) => {
      if (params?.componentType !== "series") return;
      setSelectedType(params.name);
      onTrack?.(`Graph Slice Clicked: ${params.name}`);
    },
  }), [onTrack]);

  return { rows, canRender: optionBreakdown.length > 0, chartEvents, modalOpen: !!selectedType, closeModal: reset, titleSuffix: selectedType || "", reset };
}

export function LeaseOptionsByTypeBreakdownModal({ open, onClose, rows, titleSuffix }) {
  const title = "Options by Type";
  const rowCount = Array.isArray(rows) ? rows.length : 0;
  const countLabel = `${rowCount} ${rowCount === 1 ? "Option" : "Options"}`;
  const subtitle = titleSuffix ? `${titleSuffix}  (${countLabel})` : countLabel;
  return (
    <BreakdownDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      exportFileName={titleSuffix ? `${title} - ${titleSuffix}` : title}
      columns={LEASE_OPTIONS_BY_TYPE_BREAKDOWN_COLUMNS}
      rows={rows}
    />
  );
}
